/**
 * TuanHA: 2/1/2023: Training Service
 * 
 */

import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { ApiEvsService } from "app/common/services/ApiEvs.service";

import { Observable } from "rxjs/Observable";
import { Headers, Http } from "@angular/http";

@Injectable()
export class TrainingService {
  headers: Headers;
  url = environment.qrcode_url_aps;

  constructor(private http: Http, private apiEvsService: ApiEvsService) {
    const token = localStorage.getItem("Access-Token");
    const lang = localStorage.getItem("lang");
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "accept-language": `${lang}`,
    });
  }

  getTrainingMenu(): Observable<any> {
    const lang = localStorage.getItem("lang");
    this.headers.set("accept-language", lang);
    return this.http
      .get(`${this.url}/training/menu`, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  getTrainingContent(id: number): Observable<any> {
    const lang = localStorage.getItem("lang");
    this.headers.set("accept-language", lang);
    return this.http
      .get(`${this.url}/training/menu/${id}`, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }
}


// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/training/training.service.ts